import * as queries from './queries';
import app from '../../app';

export async function getFAQ({ dispatch, rootGetters }) {
  //TODO: what do we do with categories?
  let _a;
  let roleCategory = (_a = rootGetters['faq/roleCategory']) !== null && _a !== void 0 ? _a : 'CASE_NURSES';

  try {
    const { data, errors } = await app.apolloMobileClient.query({
      query: queries.getFAQ,
      variables: { roleCategory },
    });

    if (data && !errors) {
      return data;
    } else if (errors.length) {
      errors.forEach((error) => {
        dispatch('error/submit', error, { root: true });
      });
    }

    return false;
  } catch (error) {
    dispatch('error/submit', error, { root: true });
    return false;
  }
}


